import React, { useEffect, useState } from 'react';
import { getAudits, getAudit, getSections } from '../services/api';
import '../App.css';

export default function AuditsPage({ labId }) {
  const [audits, setAudits]     = useState([]);
  const [sections, setSections] = useState([]);
  const [filter, setFilter]     = useState('');
  const [detail, setDetail]     = useState(null);
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    getSections(labId).then(r => setSections(r.data));
    loadAudits();
  }, [labId]); // eslint-disable-line

  const loadAudits = (sec) => {
    setLoading(true);
    getAudits({ lab_id: labId || undefined, section_id: sec || undefined, limit: 50 })
      .then(r => setAudits(r.data))
      .finally(() => setLoading(false));
  };

  const openAudit = async (id) => {
    const r = await getAudit(id);
    setDetail(r.data);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Audit History</div>
          <div className="page-sub">All weekly audits & receiving sessions</div>
        </div>
      </div>

      <div className="search-row">
        <select className="filter-select" value={filter} onChange={e => { setFilter(e.target.value); loadAudits(e.target.value); }}>
          <option value="">All Sections</option>
          {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </div>

      {loading ? <div className="loading">Loading…</div> : (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Date</th><th>Section</th><th>Type</th><th>By</th><th>Items</th><th>Status</th><th></th></tr>
              </thead>
              <tbody>
                {audits.length === 0 ? (
                  <tr><td colSpan={7} style={{ textAlign: 'center', color: '#94a3b8', padding: 32 }}>No audits yet</td></tr>
                ) : audits.map(a => (
                  <tr key={a.id}>
                    <td>{new Date(a.started_at).toLocaleDateString()}</td>
                    <td>{a.section_name}</td>
                    <td><span className={`badge ${a.audit_type === 'receiving' ? 'badge-blue' : ''}`}>{a.audit_type}</span></td>
                    <td>{a.conducted_by || '—'}</td>
                    <td>{a.items_counted}</td>
                    <td>
                      {a.submitted_at
                        ? <span className="badge badge-ok">Submitted</span>
                        : <span className="badge badge-low">In Progress</span>}
                    </td>
                    <td><button className="btn btn-outline btn-sm" onClick={() => openAudit(a.id)}>View</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Audit detail modal */}
      {detail && (
        <div className="modal-backdrop" onClick={() => setDetail(null)}>
          <div className="modal" style={{ maxWidth: 640 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <div className="modal-title">{detail.section_name} · {detail.audit_type}</div>
                <div style={{ fontSize: 12, color: '#64748b' }}>
                  {new Date(detail.started_at).toLocaleString()} · {detail.conducted_by}
                </div>
              </div>
              <button className="modal-close" onClick={() => setDetail(null)}>✕</button>
            </div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Item</th><th>Lot</th><th>Before</th><th>Counted</th><th>Δ</th></tr></thead>
                <tbody>
                  {detail.lines?.map((line, i) => (
                    <tr key={i}>
                      <td>{line.item_name}</td>
                      <td>{line.lot_number || '—'}</td>
                      <td>{line.qty_before}</td>
                      <td><b>{line.qty_counted}</b> {line.unit}</td>
                      <td style={{ color: line.qty_counted - line.qty_before > 0 ? '#16a34a' : line.qty_counted - line.qty_before < 0 ? '#dc2626' : '#94a3b8', fontWeight: 700 }}>
                        {line.qty_counted - line.qty_before > 0 ? '+' : ''}{(line.qty_counted - line.qty_before).toFixed(1)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
